import { AxiosResponse } from "axios";
import {
  PaginatedUnitCategories,
  UnitCategory,
  UnitCategoryPayload,
  UnitCategoryRead,
} from "@types";
import { request } from "@utils";

export const getAllUnitCategories = (
  page: number = 1,
): Promise<AxiosResponse<PaginatedUnitCategories>> => {
  const req = request();
  return req.get(`/api/v1/unit-categories/paginated?page=${page}&limit=10`);
};

export const createUnitCategory = async (
  data: UnitCategory,
): Promise<UnitCategoryRead> => {
  const res = await request().post("/api/v1/unit-categories", data);
  return res.data;
};

export const updateUnitCategory = async (
  id: string,
  data: UnitCategoryPayload,
): Promise<UnitCategoryRead> => {
  const res = await request().put(`/api/v1/unit-categories/${id}`, data);
  return res.data;
};

export const deleteUnitCategory = async (
  id: string,
): Promise<UnitCategoryRead> => {
  const res = await request().delete(`/api/v1/unit-categories/${id}`);
  return res.data;
};

export const uploadUnitCategoryVideo = async (
  id: string,
  file: File,
): Promise<UnitCategoryRead> => {
  const formData = new FormData();
  formData.append("file", file);

  const res = await request().post(
    `/api/v1/upload/unit-category/${id}`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } },
  );

  return res.data;
};
